module.exports = __webpack_public_path__ + "img/12.83f9c727.jpg";